import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

import SearchDropdownItemContainer from 'onboarding/common/SearchDropdownItem';

import 'styles/common/inline-popup.scss';

const SearchDropdown = (props) => {
  const { t } = useTranslation();

  return (
    <div className="inline-popup-wrap">
      {props.templates.map((template) => (
        <SearchDropdownItemContainer template={template} key={template.id} selectTemplate={props.selectTemplate} />
      ))}
      <div className="inline-popup-list-item" role="button" tabIndex="0" onClick={props.addNewService}>
        <div className="bullet">
          <span className="ic-sml-12px ic_add_black" />
        </div>
        <div className="text">{t('composite.addService.notListed')}</div>
        <div className="sub-text">{t('composite.addService.addNewService')}</div>
      </div>
    </div>
  );
};

export default SearchDropdown;
